//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import CustomStore from 'devextreme/data/custom_store';
import { DateResultDTO } from 'src/app/core/interfaces/general/date-result';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { lastValueFrom, map, Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { TypeLicenceDTO } from 'src/app/core/models/system/type/type-licence.dto';

@Injectable({ providedIn: 'root' })

export class TypesLicenceService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
    
  public calculateCancellationDateForNewLicence(licenceType: string): Observable<DateResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(licenceType)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const licenceTypeEnc=encResult.result;
                            
                            return this.httpClientService.get<DateResultDTO>(environment.eSimApi + 
                                                                             eSimApiPaths.TypesLicence + '/' +
                                                                             eSimApiPaths.TypesLicenceCalculateCancellationDateForNewLicence +
                                                                             "?licenceTypeEnc=" + licenceTypeEnc, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
    
  public calculateStartDateForNewLicence(licenceType: string): Observable<DateResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(licenceType)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const licenceTypeEnc=encResult.result;
                            
                            return this.httpClientService.get<DateResultDTO>(environment.eSimApi + 
                                                                             eSimApiPaths.TypesLicence + '/' +
                                                                             eSimApiPaths.TypesLicenceCalculateStartDateForNewLicence +
                                                                             "?licenceTypeEnc=" + licenceTypeEnc, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<TypeLicenceDTO[]>(environment.eSimApi + eSimApiPaths.TypesLicence)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(typeLicence: TypeLicenceDTO) {
    return {id: typeLicence.id, description: typeLicence.licenceType};
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
}
